<template>
  <div class="notfound" :style="{ 'min-height': innerHeight }">
    <div class="content-box">
      <div class="img-bg">
        <img
          style="height: 100%; width: 100%"
          src="@/assets/images/notfoundBg.png"
          alt="nofound"
        />
        <img
          class="cuise-img"
          src="@/assets/images/cuiseNot.png"
          alt="nofound"
        />
      </div>
      <div class="back-btn">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">HOME</el-breadcrumb-item>
          <el-breadcrumb-item style="cursor:default">Not-Found</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div
        style="
          z-index: 10;
          position: relative;
          margin-top: 100px;
          padding: 20px 6%;
        "
      >
        <div class="title-tips">Oops!! No restaurants found here...</div>
        <div class="title-desc">
          But if you give us your postcode, we promise we'll find the vest
          places to eat near you.
        </div>
      </div>
      <div class="search-box">
        <div class="top-box">
          <span
            :class="['type-btn', { 'btn-active': transType == 1 }]"
            @click="transType = 1"
          >
            Delivery
          </span>
          <span
            :class="['type-btn', { 'btn-active': transType == 2 }]"
            @click="transType = 2"
          >
            Pickup
          </span>
        </div>
        <div class="bottom-box">
          <div class="input-box">
            <img src="@/assets/images/location.png" alt="location-img" />
            <input
              type="text"
              v-model="keywords"
              @input="inputNow"
              @keyup="inputNow"
              placeholder="Enter Your Postccode"
              style="height: 100%; width: 100%"
            />

            <!-- 搜索结果内容 -->
            <div :class="['expand-box', { 'expand-box-active': keywords }]">
              <div
                class="search-item"
                v-for="(item, ind) in resultList"
                :key="ind"
                @click="normalSearch(item)"
              >
                <span>{{ item.content }}</span>
                <img src="@/assets/images/right.png" alt="right-arrow" />
              </div>
              <div class="load-box" v-if="loading">
                <span class="loader"></span>
              </div>
              <div class="load-box" v-else-if="!loading && !resultList.length">
                No data.
              </div>
            </div>
          </div>
          <button class="search-btn" @click="inputNow">
            <img src="@/assets/images/search.png" alt="search-img" />
            Find Food
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from "@/utils/debounce.js";
// import Lang from "../components/lang.vue";
export default {
  name: 'NotFound',
  metaInfo: {
    meta: ["All Eat "],
    title: "All Eat not found",
  },
  data() {
    return {
      transType: 1,
      keywords: "",
      resultList: [],
      loading: false,
      innerHeight: 800,
    };
  },
  components: {
    // Lang,
  },
  created() {},
  mounted() {
    this.innerHeight = window.innerHeight + "px";
  },
  methods: {
    inputNow() {
      this.resultList = [];
      this.loading = true;
      debounce(() => {
        if (this.keywords.trim().length < 3) return;
        this.$postGateway({
          method: "GET",
          url: "/customerApp/index/getPreKeyword",
          data: { keyword: this.keywords },
        })
          .then((res) => {
            if (res.data.length) {
              this.resultList = res.data.map((x) => {
                return {
                  content: x,
                  type: "content",
                };
              });
              this.loading = false;
            } else {
              this.googlePreSearch();
            }
          })
          .catch(() => {
            this.googlePreSearch();
          });
      }, 500);
    },
    googlePreSearch() {
      this.$postGateway({
        method: "GET",
        url: "/customerWeb/googleSearch/autocomplete",
        data: { keyword: this.keywords },
      })
        .then((res) => {
          this.resultList = this.resultList.concat(
            res.data.predictions.map((x) => {
              return {
                ...x,
                content: x.description,
                type: "location",
              };
            })
          );
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    normalSearch(item) {
      if (item.type == "content") {
        this.$router.push({
          path: "/browse",
          query: {
            searchName: item.content,
            lng: "",
            lat: "",
            searchLoc: "",
          },
        });
      } else if (item.type == "location") {
        this.googleSearch(item);
      }
    },
    googleSearch(item) {
      this.$postGateway({
        method: "GET",
        url: "/customerWeb/googleSearch/placeGeoCode",
        data: {
          keyword: "",
          placeId: item.place_id,
        },
      }).then((res) => {
        if (res.code == 200) {
          this.$router.push({
            path: "/browse",
            query: {
              searchName: "",
              lng: res.data.lng,
              lat: res.data.lat,
              searchLoc: res.data.formattedAddress,
              transType: this.transType,
            },
          });
          this.searchVisible = false;
        } else {
          this.$message.error("Error happen...");
        }
      });
    },
    becomePart() {
      window.open("https://alleatapp.net/become-partner/");
    },
    aboutUs() {
      window.open("https://alleatapp.net/");
    },
    goLogin() {
      this.$router.replace({
        path: "/login",
      });
    },
    goHome() {
      this.$router.replace({
        path: "/",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.notfound {
  min-height: 800px;

  .back-btn {
    position: relative;
    background: #fff;
    height: 36px;
    border-radius: 18px;
    padding: 0 20px;
    font-weight: bold;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 30px 6% 0;
  }

  .content-box {
    position: relative;
    width: 100%;
    height: 420px;
    .img-bg {
      position: absolute;
      z-index: 0;
      height: 420px;
      width: 100%;
    }

    .cuise-img {
      height: 259px;
      width: 370px;
      position: absolute;
      z-index: 1;
      right: 6%;
      top: 0px;
    }

    // tips
    .title-tips {
      font-family: "Poppins";
      font-size: 50px;
      color: #fff;
      font-weight: bold;
    }

    .title-desc {
      font-family: "Poppins";
      margin-top: 10px;
      font-size: 20px;
      color: #fff;
      letter-spacing: 0.5px;
    }
  }

  .search-box {
    position: absolute;
    z-index: 10;
    bottom: -100px;
    left: 6%;
    height: 220px;
    width: 50%;
    background: #fff;
    padding: 15px;
    box-sizing: border-box;
    border-radius: 12px;
    box-shadow: rgba(139, 79, 201, 0.5) 0px 5px 20px,
      rgba(139, 79, 201, 0.23) 0px 6px 6px;
    display: flex;
    flex-direction: column;

    .top-box {
      height: 48px;
      border-radius: 4px;
      color: #222;
      font-weight: bold;
      font-size: 15px;
      display: inline-flex;
      align-items: center;

      .type-btn {
        cursor: pointer;
        display: inline-flex;
        margin-right: 20px;
        height: 42px;
        border-radius: 4px;
        justify-content: center;
        width: 120px;
        align-items: center;
        background: #e9eaea;
        font-weight: bold;
        transition: all 0.2s ease-in-out 0s;

        &:hover {
          background: #cbcdcd;
          color: #fff;
        }
      }

      .btn-active {
        background: #09ca6a;
        color: #fff;

        &:hover {
          background: #049d51;
        }
      }
    }

    .bottom-box {
      flex: 1;
      display: flex;
      align-items: center;

      .input-box {
        height: 48px;
        background: #f5f5f5;
        padding: 0 20px;
        flex: 1;
        display: inline-flex;
        align-items: center;
        position: relative;

        .expand-box {
          position: absolute;
          width: 100%;
          height: 0px;
          top: 48px;
          left: 0;
          background: rgba(255, 255, 255, 0.95);
          padding: 20px 0;
          height: 0px;
          opacity: 0;
          transition: all 0.8s ease-in-out 0s;

          .search-item {
            height: 50px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #e9e9e9;
            padding: 0 20px;
            cursor: pointer;

            &:hover {
              background-color: rgba(236, 230, 230, 0.95);
            }

            span {
              flex: 1;
            }

            img {
              height: 18px;
              width: 25px;
            }
          }
        }

        .load-box {
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          .loader {
            width: 48px;
            height: 48px;
            border: 5px solid #fff;
            border-bottom-color: #ff3d00;
            border-radius: 50%;
            display: inline-block;
            box-sizing: border-box;
            animation: rotation 1s linear infinite;
          }

          @keyframes rotation {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        }

        .expand-box-active {
          height: 300px;
          opacity: 1;
          overflow-y: scroll;
        }

        input {
          background: transparent;
          font-weight: normal;
        }

        img {
          height: 20px;
          width: 20px;
          margin-right: 10px;
        }
      }

      .search-btn {
        height: 48px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        background: #09ca6a;
        color: #fff;
        font-weight: bold;
        margin-left: 10px;
        padding: 0 20px;
        font-size: 17px;
        cursor: pointer;
        transition: all 0.2s ease-in-out 0s;

        img {
          height: 18px;
          width: 18px;
          margin-right: 10px;
        }
        &:hover {
          background: #049d51;
          color: #e8e4e4;
        }
      }
    }
  }
}

button {
  border: none;
}
input {
  border: none;
  outline: none;
  font-weight: bold;
  font-size: 20px;
}
</style>
